
import { get, post } from './http'
//获取案例展示
export const indexExample = data => get('/index/example', data);

//获取七牛地址 
export const qiniu = data => get('/qiniu', data);

//品牌展示
export const indexBrand = data => get('/index/brand', data);

//网页底部配置 
export const indexBottomConfig = data => get('/index/bottomConfig', data);

//数据展示
export const indexRecord = data => get('/index/record', data);

//数据展示
export const banner = data => get('/index/banner', data);

//线索添加
export const addClue = data => post('/index/addClue', data);

